import React from 'react'
import Rowrecord from '../../fastparity/order/Rowrecord'
import './EveryOneOrder.css'
const EveryOneOrder = () => {
  return (
    <>
      <table className="table-everyone-order">
        <tr className="table-everyone-order-heading">
          <td className="text-align-tb">Period</td>
          <td className="text-align-tb">User</td>
          <td>Select</td>
          <td>Point</td>
        </tr>
         <Rowrecord/>
         <Rowrecord/>
         <Rowrecord/>
         <Rowrecord/>
      </table>
    
    </>
  )
}

export default EveryOneOrder